import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const StoreCtx = createContext(null);

export function StoreProvider({ children }) {
  const [data, setData] = useState({ categories: [], products: [], site_images: {}, settings: null, loading: true });

  const reload = useCallback(async () => {
    try {
      const { data: d } = await api.get("/store/catalog");
      setData({ ...d, loading: false });
    } catch {
      setData((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const value = {
    ...data,
    reload,
    category: (id) => data.categories.find((c) => c.id === id),
    product: (id) => data.products.find((p) => p.id === id),
    productsIn: (id) =>
      (id === "ready" ? data.products.filter((p) => p.kind === "ready-to-wear") : data.products.filter((p) => p.category === id))
        .sort((a, b) => (a.stock === 0) - (b.stock === 0)),
  };
  return <StoreCtx.Provider value={value}>{children}</StoreCtx.Provider>;
}

export const useStore = () => useContext(StoreCtx);
